import { useRoomContext } from "@livekit/components-react";
import {
  Participant,
  RoomEvent,
  TrackPublication,
  TranscriptionSegment,
} from "livekit-client";
import { useEffect } from "react";

export function useOnTranscriptions(
  onTranscription: (
    transcription: TranscriptionSegment[],
    participant?: Participant | undefined,
    publication?: TrackPublication | undefined,
  ) => void,
) {
  const room = useRoomContext();

  useEffect(() => {
    if (!room) return;

    room.on(RoomEvent.TranscriptionReceived, onTranscription);

    return () => {
      room.off(RoomEvent.TranscriptionReceived, onTranscription);
    };
  }, [room, onTranscription]);
}
